import { $, $$, onReady, isMobile } from './js/env';
import { initScale, ratio } from './js/scale';
import { initTheme } from './js/theme';
import { initAudio } from './js/audio';
import { initReveal } from './js/reveal';
import { initLoader } from './js/loader';
import { Fullpage } from './js/fullpage';

// Mobile: link tới màn trên trang chủ (/#tin-tuc) → cuộn mượt, chừa chỗ cho header cố định
function initMobileAnchors() {
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a || e.defaultPrevented) return;
    const url = new URL(a.href, window.location.href);
    if (url.pathname !== window.location.pathname && !/\/(index\.html)?$/.test(url.pathname)) return;
    const target = url.hash && document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target || !target.hasAttribute('data-frame')) return;
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('nth:navigate', { detail: { id: target.id } }));
    const header = $('.mb-header');
    const offset = header ? header.getBoundingClientRect().height : 0;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
  });
}

// Mobile trang chủ: đánh dấu mục menu của màn đang nằm giữa màn hình (cuộn tự nhiên, không có fullpage)
function initScrollSpy() {
  const frames = $$('[data-frame]:not([data-frame-drawer])');
  if (!frames.length || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      $$('a[href*="#"]').forEach((a) => {
        const on = a.getAttribute('href').split('#')[1] === en.target.id;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    });
  }, { rootMargin: '-45% 0px -50% 0px' });
  frames.forEach((f) => io.observe(f));
}

// Link /#mon-phai chỉ dùng để VÀO đúng màn; vào xong xoá hash (và không ghi hash khi chuyển màn)
// → F5 luôn về màn đầu thay vì kẹt ở màn đã xem.
const dropHash = () => {
  if (window.location.hash) window.history.replaceState(null, '', window.location.pathname + window.location.search);
};

onReady(() => {
  initScale();
  initTheme();
  initAudio();

  const fp = $('[data-fullpage]');
  if (fp && !isMobile()) {
    document.documentElement.classList.add('is-fp');
    // chạy sau khi mọi component trong bundle đã đăng ký lắng nghe 'nth:frame';
    // loader đo ảnh LCP sau khi màn đầu đã được bật (tránh đọc layout trong khung đang ẩn)
    queueMicrotask(() => {
      new Fullpage(fp).init();
      dropHash();
      initLoader();
    });
  } else {
    initLoader();
    initReveal();
    initMobileAnchors();
    initScrollSpy();
    // vào trang bằng link /#mon-phai trên mobile: cuộn tới đúng màn sau khi đã scale
    // F5 giữa trang: trình duyệt mặc định cuộn lại chỗ cũ → tắt để luôn về đầu trang
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    const toHash = (behavior) => {
      const t = window.location.hash && document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
      if (t) requestAnimationFrame(() => window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 87 * ratio(), behavior }));
      dropHash();
      return Boolean(t);
    };
    if (!toHash('auto') && fp) window.scrollTo(0, 0);
    window.addEventListener('hashchange', () => toHash('smooth'));
  }
});
